// extracted by mini-css-extract-plugin
module.exports = {"unitSlide":"listing-carousel-slide_unitSlide__n_Qia"};